export default {
    'en': {
        currency: {

            style: 'currency', currency: 'USD'

        },
        decimal: {

            style: 'decimal'

        }
     
    },
    'de': {

        currency: {

            style: 'currency', currency: 'JPY', currencyDisplay: 'symbol'

        },
        decimal: {

            style: 'decimal'

        }

    },
    'zh': {

        currency: {

            style: 'currency', currency: 'CNY'

        },
        decimal: {

            style: 'decimal'

        }

    }
};



// WEBPACK FOOTER //
// ./src/lang/numberFormats.js